import { createAction } from 'redux-actions';

export const FETCHED_CUPONS = 'FETCHED_CUPONS';

export const fetchedCupons = createAction(FETCHED_CUPONS, data => data);
